import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  // device_status: yup.string().required(),
  search_product: yup.string().required(),
  // device_factor: yup.string().required(),
});
